import { PostsWidgetContext } from '../Posts.context'
import { usePostsWidgetsData } from '../Posts.hooks'

function PostsContextProvider({ children, isInitiated }) {
  const { widgets } = usePostsWidgetsData({ isInitiated })

  return <PostsWidgetContext value={{ widgets }}>{children}</PostsWidgetContext>
}

export default PostsContextProvider
